import { createAsyncThunk } from '@reduxjs/toolkit';

import doFetch from 'utils/doFetch';

import type { AppGetState } from '../../index';

const attachPaymentsMethodThunk = createAsyncThunk(
  'paymentsMethods/attachPaymentsMethod',
  async ({ id }: { id: string }, { getState }) => {
    const apiPointName = 'attachPaymentsMethod';
    const store = (getState as AppGetState)();
    const token = store.jwt.token;
    let headers = {};

    if (token) {
      headers = {
        ...headers,
        Authorization: `Bearer ${token}`,
      };
    }

    return await doFetch<typeof apiPointName>({
      apiPointName,
      body: { payment_method_id: id },
      headers,
    });
  },
);

export default attachPaymentsMethodThunk;
